/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\CollapsRow\CollapsRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Tuesday October 15th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday October 15th 2024 5:10:50 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useState } from "react";
import { Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Styles from "Content/Cart/OfferRowUserSingle/OfferRowUser.module.css";

type CollapsRowProps = {
    children: JSX.Element[],
    collapseChildren: JSX.Element
}

export default function CollapsRow(props: CollapsRowProps) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow hover={true}>
                <TableCell align="center" className={`${Styles.fileArrow}`} onClick={() => setOpen(!open)} >
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                {props.children}
            </TableRow>
            {/* { open ? */}
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                        <Collapse in={open} timeout="auto">
                            {props.collapseChildren}
                        </Collapse>
                    </TableCell>
                </TableRow>
                {/* : null */}
            {/* } */}

        </>

    );
};
